'use client';

import { useLocale } from 'next-intl';

import { Button } from '../../../../components/Button';
import { Link } from '../../../../components/Link';
import { useIsCustomDomain } from '../../../../context/CustomDomainContext';
import { resolveRoute } from '../../../../util/routeResolver';

export const NotFoundRedirectButton = ({ label }: { label: string }) => {
  const isCustom = useIsCustomDomain();
  const locale = useLocale();

  // On custom domains, navigate to root (middleware handles company resolution)
  // On non-custom domains, read companyId from the current URL search params
  const searchParams = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null;
  const companyId = isCustom ? undefined : searchParams?.get('companyId') || undefined;
  const href = resolveRoute('jobList', { locale, companyId });

  return (
    <div style={{ marginTop: 12 }}>
      <Link href={href}>
        <Button data-guide-id="not-found-back-btn">{label}</Button>
      </Link>
    </div>
  );
};
